export default __webpack_public_path__ + "locales/sk/ConvertDialog.json?hash=4dd7577f52e69576847acb0c9672dfc9";